import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import '../styles/index.scss';

/**
 * This component implements a container which lays out content items in a
 * left-to-right, then top-to-bottom manner. Content items are passed in as
 * children to this component. Items in the same row take up even space.
 * Depending on screen resolution, the number of items on each row and the
 * gutter size would differ.
 */
const StackedContainer = ({children, className}) => {
  return (
    <div className={cx('stacked-container', className)}>
      {children.map((child, index) => (
        <div className={cx('stacked-container__item', className)} key={index}>
          {child}
        </div>
      ))}
    </div>
  );
};

StackedContainer.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
};

export default StackedContainer;
